import { render } from "./SurfaceEffectiveLumNat.vue?vue&type=template&id=5851bff7"
const script = {}

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__